const horizontalMap = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
    spaceBetween: 'normal',
    none: 'normal',
};
const verticalMap = {
    top: 'flex-start',
    center: 'center',
    bottom: 'flex-end',
    spaceBetween: 'normal',
    none: 'normal',
};
export const getAlignItems = (direction, horizontalAlign, verticalAlign) => {
    return direction === 'row'
        ? verticalMap[verticalAlign]
        : horizontalMap[horizontalAlign];
};
